import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { Cookie, X } from 'lucide-react';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setVisible(false);
  };

  const refuse = () => {
    localStorage.setItem('cookie_consent', 'refused');
    setVisible(false);
  };

  if (!visible || pathname.startsWith('/easer') || pathname.startsWith('/client') || pathname.startsWith('/admin')) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] p-4 sm:p-6" data-testid="cookie-banner">
      <div className="max-w-4xl mx-auto bg-card border border-border rounded-2xl shadow-2xl p-5 sm:p-6">
        <div className="flex items-start gap-4">
          <div className="w-10 h-10 rounded-xl bg-[hsl(var(--brand-mint))] flex items-center justify-center flex-shrink-0">
            <Cookie className="h-5 w-5 text-[hsl(var(--primary))]" />
          </div>
          <div className="flex-1">
            <h3 className="font-['Space_Grotesk'] font-semibold text-sm mb-1">Ce site utilise des cookies</h3>
            <p className="text-xs text-muted-foreground leading-relaxed mb-4">
              Nous utilisons des cookies strictement nécessaires au bon fonctionnement du site. Aucun cookie publicitaire ou de suivi n'est utilisé.
              En continuant votre navigation, vous acceptez l'utilisation de ces cookies.
              <Link to="/cookies" className="text-[hsl(var(--primary))] underline ml-1">En savoir plus</Link>
            </p>
            <div className="flex flex-wrap gap-2">
              <Button size="sm" onClick={accept} className="bg-[hsl(var(--primary))] hover:bg-[hsl(var(--primary))]/90 text-white" data-testid="cookie-accept">
                Accepter
              </Button>
              <Button size="sm" variant="outline" onClick={refuse} data-testid="cookie-refuse">
                Refuser les optionnels
              </Button>
              <Link to="/cookies">
                <Button size="sm" variant="ghost" className="text-xs">
                  Paramétrer
                </Button>
              </Link>
            </div>
          </div>
          <button onClick={refuse} className="text-muted-foreground hover:text-foreground">
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
